import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetAuftragMutation, useGetHistoriePrivateMutation, useSpeicherAuftragMutation } from '../../api/AuftragAPI';
import UploadToServer from '../../component/UploadToServer';
import { IAuftrag, IAuftraggeber, IAuftragHistorie, IAuftragRequest } from '../../types/Types';
import { formatToEuroDate, formatToEuroDateTime } from '../../util/DateUtils';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import stylesDetails from './auftragdetails.module.scss';
import MapComponent, { ILocation } from '../../component/MapComponent/MapComponent';

const emptyAuftraggeber: IAuftraggeber = {
  name: '',
  uid: ''
}

const emptyAuftrag: IAuftrag = {
  uid: '',
  art: '',
  status: '',
  createDate: new Date(),
  aktuellerTermin: null,
  wiedervorlage: null,
  auftraggeber: emptyAuftraggeber,
  vorname_endkunde: '',
  name_endkunde: '',
  strasse_lieferadresse: '',
  hausnummer_lieferadresse: '',
  postleitzahl_lieferadresse: '',
  stadt_lieferadresse: '',
  land_lieferadresse: '',
  telefon_lieferadresse: '',
  mobil1_lieferadresse: '',
  mobil2_lieferadresse: '',
  email: '',
  spaetmesstermin: null,
  besonderheiten: '',
  messzeitpunkt: '',
  ansprechpartner: '',
  auftragsnr_ag: '',
  kontakt_ansprechpartner: '',
  ausfuehrungvon: null,
  lat: 0,
  lng: 0,
}

/**
 * @author noone
 */
export default function AuftragDetails() {
  var url = window.location;
  let params = new URLSearchParams(url.search);
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [speicherAuftrag] = useSpeicherAuftragMutation();
  const [getAuftragAPI] = useGetAuftragMutation();
  const [getAuftragHistoriePrivate] = useGetHistoriePrivateMutation();

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [spaetmesstermin, setSpaetmesstermin] = useState<string>(""); // ist nicht schön, ich weiss
  const [auftrag, setAuftrag] = useState<IAuftrag>(emptyAuftrag);
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);

  const locationSet = (location: ILocation) => {

    // TODO
    if (auftrag !== undefined) {
      setAuftrag((prevData) => {
        return {
          ...prevData,
          strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
          hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
          postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
          stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
          land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
          lat: location.lat,
          lng: location.lng,
        };
      });
    }
  }
  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAuftrag((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));

    if (e.target.name === "spaetmesstermin") {
      setSpaetmesstermin(e.target.value);
    }
  }

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAuftrag((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const speichern = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    const auf: IAuftragRequest = {
      uid: auftrag.uid,
      art: auftrag.art,
      vorname_endkunde: auftrag.vorname_endkunde,
      name_endkunde: auftrag.name_endkunde,
      strasse_lieferadresse: auftrag.strasse_lieferadresse,
      hausnummer_lieferadresse: auftrag.hausnummer_lieferadresse,
      postleitzahl_lieferadresse: auftrag.postleitzahl_lieferadresse,
      stadt_lieferadresse: auftrag.stadt_lieferadresse,
      land_lieferadresse: auftrag.land_lieferadresse,
      telefon_lieferadresse: auftrag.telefon_lieferadresse,
      mobil1_lieferadresse: auftrag.mobil1_lieferadresse,
      mobil2_lieferadresse: auftrag.mobil2_lieferadresse,
      email_lieferadresse: auftrag.email,
      besonderheiten: auftrag.besonderheiten,
      messzeitpunkt: auftrag.messzeitpunkt,
      spaetmesstermin: auftrag.spaetmesstermin,
      auftragsnr_ag: auftrag.auftragsnr_ag,
      ansprechpartner: auftrag.ansprechpartner,
      kontakt_ansprechpartner: auftrag.kontakt_ansprechpartner,
      lat: auftrag.lat,
      lng: auftrag.lng,
    }
    speicherAuftrag(auf);

  }

  useEffect(() => {
    const uid = params.get('uid');
    getAuftragAPI(uid!!).unwrap().then((data) => {
      setAuftrag(data);
      setIsLoaded(true);

      const formattedDate: Date | string = data?.spaetmesstermin
        ? data.spaetmesstermin
        : "";

      setSpaetmesstermin("" + formattedDate);

    });

    getAuftragHistoriePrivate(uid!!).unwrap().then((data) => setHistorie(data));
  }, []);

  return (
    <div>

      <LandingpageHeader />

      <div className={stylesDetails.containerAuftragDetails} >
        <button
          onClick={() => {
            navigate("../", {
              relative: "path"
            });
          }}

          style={{ marginBottom: "20px" }}
          className=' btn btn-outline-primary'
        >
          <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
        </button>

        <div className={stylesDetails.contentDiv}>
          {isLoaded &&
            <>
              <div>

                <form className='form-group'>

                  <div className="form-group">
                    {t('deTranslation.auftragDetails.art')}:
                    <input readOnly={true} className='form-control' name="art" value={auftrag?.art} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    Auftraggeber:
                    <input readOnly={true} className='form-control' name="auftraggeber" value={auftrag?.auftraggeber.name} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    Spätester Messtermin:
                    <input type="date" className="form-control" name="spaetmesstermin" value={spaetmesstermin} onChange={handleChange} ></input>
                  </div>

                  <div className="form-group">
                    Vorname Endkunde:
                    <input className='form-control' name="vorname_endkunde" value={auftrag?.vorname_endkunde} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    Name Endkunde:
                    <input className='form-control' name="name_endkunde" value={auftrag?.name_endkunde} onChange={handleChange} />
                  </div>

                  <div className={stylesDetails.strasseHausnr}>

                    <div className="form-group">
                      Straße Endkunde:
                      <input className='form-control' name="strasse_lieferadresse" value={auftrag?.strasse_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Hausnummer Endkunde:
                      <input className='form-control' name="hausnummer_lieferadresse" value={auftrag?.hausnummer_lieferadresse} onChange={handleChange} />
                    </div>

                  </div>

                  <div className={stylesDetails.plzOrt}>

                    <div className="form-group">
                      Postleitzahl Lieferadresse:
                      <input className='form-control' name="postleitzahl_lieferadresse" value={auftrag?.postleitzahl_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Stadt Lieferadresse:
                      <input className='form-control' name="stadt_lieferadresse" value={auftrag?.stadt_lieferadresse} onChange={handleChange} />
                    </div>

                    {/*<div className="form-group">
                  Land lieferadresse:
                  <input className='form-control' name="land_lieferadresse" value={auftrag?.land_lieferadresse} onChange={handleChange} />
                </div>*/}
                  </div>

                  <div className={stylesDetails.kontakt}>

                    <div className="form-group">
                      Email:
                      <input className='form-control' name="email" value={auftrag?.email} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Telefon Lieferadresse:
                      <input className='form-control' name="telefon_lieferadresse" value={auftrag?.telefon_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Mobil 1:
                      <input className='form-control' name="mobil1_lieferadresse" value={auftrag?.mobil1_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Mobil 2:
                      <input className='form-control' name="mobil2_lieferadresse" value={auftrag?.mobil2_lieferadresse} onChange={handleChange} />
                    </div>

                  </div>

                  <div className="form-group">
                    Besonderheiten:
                    <textarea className='form-control' name="besonderheiten" value={auftrag?.besonderheiten} onChange={handleChangeTextArea} />
                  </div>

                  <div className="form-group" style={{ display: "none" }}>
                    Lat:
                    <input readOnly={true} className='form-control' name="lat" value={auftrag?.lat} onChange={handleChange} />
                  </div>

                  <div className="form-group" style={{ display: "none" }}>
                    Lng:
                    <input readOnly={true} className='form-control' name="lng" value={auftrag?.lng} onChange={handleChange} />
                  </div>


                  <div className="form-group">
                    <input type="submit" className='btn btn-primary' value="Speichern" onClick={speichern} />
                  </div>

                </form>


              </div>

              <div>

                <UploadToServer uid={auftrag.uid} />

                <div>

                  <MapComponent onLocationSet={locationSet} startLat={auftrag.lat} startLng={auftrag.lng}/>

                </div>

                <div>

                  Historie

                  <ul>
                    {historie?.map((e, index) =>
                      <li key={index}>{(e.datum !== null) ? formatToEuroDateTime(e.datum) : "--"} {e.text!!}</li>
                    )}
                  </ul>
                </div>
              </div>


            </>}
        </div>
      </div>
      <Footer />
    </div>
  );

}

export type IFilesFromAuftrag = {
  files: IDateiliste[],
}

export type IDateiliste = {
  uid: string,
  filename: string,
  createDateTime: Date,
  data: string,
  mime: string,
}